<app-product
  *ngIf="product"
  [alias]="product.alias"
  [photo]="product.menuPhoto"
  [caption]="product.caption"
  [summary]="product.summary"
  [notice]="product.notice"
  [price]="$any(product.prices[0]?.[1])"
  [discount]="discount$ | async"
  (buttonClick)="onButtonClick()"
></app-product>
